var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowSliderPrev = function SvgArrowSliderPrev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.5 4.11 0l.866.949L2.19 4H124v1H2.19l2.786 3.051L4.11 9 0 4.5Z",
    fill: "#8B8B95"
  })));
};

export default SvgArrowSliderPrev;